import { FilterSelection } from "src/app/components/filters/filters.component";
import { GlobalFiltersService } from "src/app/components/filters/services/global-filters.service";
import { FilterValue, MappedFilter } from "src/app/products/services/filters-adapter.service";

export class FilterManagement {

    constructor(public globalFiltersService: GlobalFiltersService) { }

    updateFilter(selectedFilter: FilterValue, availableFilterAttributes: MappedFilter[] | null) {// will store checked filters
        const filtersApplied: FilterSelection[] = [];

        // combinedFilters will stored all the checked and unchecked filters using this logic
        const updatedFilter = availableFilterAttributes?.map(filterGroup => {

            // select unselect filter checkboxes logic
            filterGroup.filters = filterGroup.filters?.map(_filter => {
                if (_filter?.value === selectedFilter.value && _filter?.id === selectedFilter.id) {
                    _filter.checked = !_filter?.checked;return _filter;
                } else {
                    return _filter;
                }
            });

            filterGroup.filters.forEach(filterValue => {
                filterValue.checked ? filtersApplied.push({
                    filter: filterValue,
                    type: filterGroup.type,
                    label: filterGroup?.label,
                    id: filterValue?.id
                }) : null;
            });

            // return selected and unselected filters
            return filterGroup;
        }) as MappedFilter[];// Note: Don't update aggregations here - it should only be updated when refresh=true
        this.globalFiltersService.applyFilters(filtersApplied);
    }

    resetAllFilters(availableFilterAttributes: MappedFilter[] | null) {

        const updatedFilter = availableFilterAttributes?.map(filterGroup => {

            // unselect all filter checkboxes logic
            filterGroup.filters = filterGroup.filters.map(_filter => {
                _filter.checked = false
                return _filter;
            });

            // return all filters
            return filterGroup;
        }) as MappedFilter[];

        this.globalFiltersService.updateAggregations(updatedFilter);
        // emit checked filters to product layout through filterService
        this.globalFiltersService.clearFilters();
    }
}
